// @ts-nocheck
import type { Question } from '../types';

export const weatherConditionsQuestions: Question[] = [
  {
    id: 'q-wc-1',
    topic: 'General',
    question: 'You are driving in heavy rain. What should you do?',
    options: [
      { id: 'q-wc-1o1', text: 'Reduce speed and increase following distance' },
      { id: 'q-wc-1o2', text: 'Continue driving at normal speed' },
      { id: 'q-wc-1o3', text: 'Speed up to get through the rain quickly' }
    ],
    answerId: 'q-wc-1o1',
    explanation: 'In heavy rain, reduce your speed and increase your following distance to account for reduced visibility and longer stopping distances.',
    subject: 'Weather Conditions',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/weather-rain-bend.jpg'
  },
  {
    id: 'q-wc-2',
    topic: 'General',
    question: 'You are driving in fog. What should you do?',
    options: [
      { id: 'q-wc-2o1', text: 'Use low beam headlights and reduce speed' },
      { id: 'q-wc-2o2', text: 'Use high beam headlights for better visibility' },
      { id: 'q-wc-2o3', text: 'Continue driving at normal speed' }
    ],
    answerId: 'q-wc-2o1',
    explanation: 'In fog, use low beam headlights (high beams reflect off fog and reduce visibility) and reduce your speed significantly.',
    subject: 'Weather Conditions',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/weather-fog-motorway.jpg'
  },
  {
    id: 'q-wc-3',
    topic: 'General',
    question: 'You are driving in snow. What should you do?',
    options: [
      { id: 'q-wc-3o1', text: 'Reduce speed and use gentle braking' },
      { id: 'q-wc-3o2', text: 'Continue driving at normal speed' },
      { id: 'q-wc-3o3', text: 'Speed up to get through the snow quickly' }
    ],
    answerId: 'q-wc-3o1',
    explanation: 'In snow, reduce your speed and use gentle braking to avoid skidding. Sudden movements can cause loss of control.',
    subject: 'Weather Conditions',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/weather-snow.jpg'
  },
  {
    id: 'q-wc-4',
    topic: 'General',
    question: 'You are driving in strong winds. What should you do?',
    options: [
      { id: 'q-wc-4o1', text: 'Reduce speed and hold the steering wheel firmly' },
      { id: 'q-wc-4o2', text: 'Continue driving at normal speed' },
      { id: 'q-wc-4o3', text: 'Speed up to get through the wind quickly' }
    ],
    answerId: 'q-wc-4o1',
    explanation: 'In strong winds, reduce your speed and hold the steering wheel firmly to maintain control of your vehicle.',
    subject: 'Weather Conditions'
  },
  {
    id: 'q-wc-5',
    topic: 'General',
    question: 'You are driving on a motorway at 100 km/h and it starts raining. What should you do?',
    options: [
      { id: 'q-wc-5o1', text: 'Reduce speed and increase following distance' },
      { id: 'q-wc-5o2', text: 'Continue at 100 km/h' },
      { id: 'q-wc-5o3', text: 'Speed up to get through the rain quickly' }
    ],
    answerId: 'q-wc-5o1',
    explanation: 'When it starts raining, reduce your speed and increase following distance. Wet roads reduce tire grip and increase stopping distance.',
    subject: 'Weather Conditions',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/weather-rain-motorway.jpg'
  },
  {
    id: 'q-wc-6',
    topic: 'General',
    question: 'You are driving in icy conditions. What should you do?',
    options: [
      { id: 'q-wc-6o1', text: 'Drive very slowly and use gentle steering and braking' },
      { id: 'q-wc-6o2', text: 'Continue at normal speed' },
      { id: 'q-wc-6o3', text: 'Brake hard when needed' }
    ],
    answerId: 'q-wc-6o1',
    explanation: 'In icy conditions, drive very slowly and use gentle steering and braking. Sudden movements can cause loss of control.',
    subject: 'Weather Conditions',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/weather-ice-1.jpg'
  },
  {
    id: 'q-wc-7',
    topic: 'General',
    question: 'You are driving in heavy rain and see standing water on the road. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/q-wc-7-standing-water.jpg',
    options: [
      { id: 'q-wc-7o1', text: 'Reduce speed and avoid the standing water if possible' },
      { id: 'q-wc-7o2', text: 'Continue at normal speed' },
      { id: 'q-wc-7o3', text: 'Speed up to get through quickly' }
    ],
    answerId: 'q-wc-7o1',
    explanation: 'Standing water can cause aquaplaning. Reduce speed and avoid driving through deep water if possible.',
    subject: 'Weather Conditions'
  },
  {
    id: 'q-wc-8',
    topic: 'General',
    question: 'What is aquaplaning and what causes it?',
    options: [
      { id: 'q-wc-8o1', text: 'Aquaplaning occurs when water between tire and road reduces grip' },
      { id: 'q-wc-8o2', text: 'Aquaplaning is normal in rainy conditions' },
      { id: 'q-wc-8o3', text: 'Aquaplaning is caused by worn brake pads' }
    ],
    answerId: 'q-wc-8o1',
    explanation: 'Aquaplaning occurs when a layer of water builds up between your tires and the road surface, reducing or eliminating grip. This is especially dangerous at high speeds.',
    subject: 'Weather Conditions'
  },
  {
    id: 'q-wc-9',
    topic: 'General',
    question: 'How should you react if you experience aquaplaning?',
    options: [
      { id: 'q-wc-9o1', text: 'Brake hard immediately' },
      { id: 'q-wc-9o2', text: 'Reduce speed gradually and avoid sudden movements' },
      { id: 'q-wc-9o3', text: 'Turn the steering wheel sharply' }
    ],
    answerId: 'q-wc-9o2',
    explanation: 'If you experience aquaplaning, remain calm and reduce speed gradually without braking hard. Sudden movements can cause loss of control. The tires will regain grip as speed decreases.',
    subject: 'Weather Conditions'
  },
  {
    id: 'q-wc-20',
    topic: 'General',
    question: 'How does snow and ice reduce tire grip on the road?',
    options: [
      { id: 'q-wc-20o1', text: 'It reduces the contact area between tire and road surface' },
      { id: 'q-wc-20o2', text: 'It has no effect on tire grip' },
      { id: 'q-wc-20o3', text: 'It increases tire grip' }
    ],
    answerId: 'q-wc-20o1',
    explanation: 'Snow and ice reduce the contact area between the tire and the road surface, significantly reducing grip. This is why special winter tires are recommended for better grip in cold conditions.',
    subject: 'Weather Conditions',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/weather-conditions/weather-ice-2.jpg'
  }
];






